// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'person';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.75 2.813a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0zm6.188 7.312a3.937 3.937 0 1 0-7.876 0v1.688H6.75l.563 5.624h3.375l.562-5.625h1.688z'
  />
);

export const viewBox = '0 0 18 18';
